import translating from './translate.json';
import { validateForm } from '../../utils';

const fields = (categoriesList, regionEnum, isCreate) => {
  const fieldsArr = [
    {
      name: 'first_name',
      label: translating.firstName,
      pattern: validateForm('first_name', translating.firstName),
      required: true
    },
    {
      name: 'last_name',
      label: translating.lastName,
      pattern: validateForm('last_name', translating.lastName),
      required: true
    },
    {
      name: 'ssn',
      label: translating.tz,
      type: 'number',
      pattern: validateForm('ssn', translating.tz),
      required: true
    },
    {
      name: 'torForYouUuid',
      label: translating.torforuuuid
    },
    {
      name: 'roleId',
      label: translating.therapistOrMS,
      required: true,
      default: '6',
      type: 'radio',
      options: [
        { id: '6', name: 'מטפל' },
        { id: '8', name: 'צוות רפואי' }
      ],
      byId: true
    },
    {
      name: 'categoryId',
      label: translating.type,
      type: 'select',
      options: categoriesList,
      required: true
    },
    {
      name: 'mobile',
      required: true,
      label: translating.mobile,
      pattern: validateForm('mobile', translating.mobile)
    },
    {
      name: 'phone',
      label: translating.phone,
      pattern: validateForm('phone', translating.phone)
    },
    {
      name: 'email',
      label: translating.email,
      required: true,
      pattern: validateForm('email', translating.email)
    },
    {
      name: 'region',
      label: translating.terapistRegion,
      required: true,
      type: 'select',
      default: 'כללי',
      options: regionEnum
    },
    {
      name: 'address',
      label: translating.address,
      width: '300px',
      required: true
    },
    {
      name: 'Hourly_fee',
      label: translating.payPerHour,
      type: 'number',
      width: '87px',
      required: true
    },
    {
      name: 'isActive',
      label: translating.status,
      type: 'switch',
      default: true
    },
    {
      name: 'zoomEmail',
      label: translating.zoomEmail,
      pattern: validateForm('email', translating.email)
    }
  ];
  if (isCreate)
    fieldsArr.push({
      name: 'password',
      required: true,
      label: translating.password,
      type: 'password',
      pattern: validateForm('password', translating.password)
    });
  return fieldsArr;
};

export default fields;
